import { render, staticRenderFns } from "./PrintSetingAside.vue?vue&type=template&id=0b973cc6&scoped=true"
import script from "./PrintSetingAside.vue?vue&type=script&lang=js"
export * from "./PrintSetingAside.vue?vue&type=script&lang=js"
import style0 from "./PrintSetingAside.vue?vue&type=style&index=0&id=0b973cc6&prod&scoped=true&lang=css"
import style1 from "./PrintSetingAside.vue?vue&type=style&index=1&id=0b973cc6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b973cc6",
  null
  
)

export default component.exports